import { useEffect, useRef, useState } from "react";
import { X } from "lucide-react";
import { useI18n } from "@/i18n";
import { sendEvent } from "@/lib/analytics";

const WHATSAPP_URL = "https://wa.me/18627775650";

// Floating purple "Help" bubble (bottom-right). Clicking it opens a small
// prompt that links visitors straight into a WhatsApp chat with support.
export default function HelpBubble() {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    const onClick = (e) => { if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClick);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClick);
    };
  }, [open]);

  const toggle = () => {
    if (!open) sendEvent("help_bubble_open");
    setOpen(!open);
  };

  return (
    <div className="help-bubble-root" ref={rootRef}>
      {open ? (
        <div className="help-popover" role="dialog" aria-label={t("helpBubble")} data-testid="help-popover">
          <button className="help-popover-close" onClick={() => setOpen(false)} aria-label="Close" data-testid="help-close">
            <X size={14} />
          </button>
          <p className="help-popover-text">
            {t("helpPromptPre")}
            <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" className="help-whatsapp-link" data-testid="help-whatsapp-link">
              WhatsApp
            </a>
            {t("helpPromptPost")}
          </p>
        </div>
      ) : null}
      <button
        type="button"
        className="help-bubble"
        onClick={toggle}
        aria-expanded={open}
        data-testid="help-bubble"
      >
        {t("helpBubble")}
      </button>
    </div>
  );
}
